<template>
    <div class="shape shape-style-1 shape-ptwist">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
    </div>
</template>
<script>
export default {
  name: 'bubbles-background'
}
</script>
